import { AdminRole } from "@repo/api-dtos"
import { createFileRoute } from "@tanstack/react-router"
import { Skeleton } from "@/components/ui/skeleton"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import {
	CRAWL_SETTINGS_DESCRIPTION,
	CRAWL_SETTINGS_TITLE,
	CrawlConfigEditor,
} from "@/features/crawl-config/CrawlConfigEditor"
import { useCrawlConfig } from "@/queries/marketplace"

export const Route = createFileRoute("/crawl/settings")({
	component: CrawlSettingsPage,
})

function CrawlSettingsPage() {
	const { hasAnyRole, hasRole } = useAdminRolesContext()
	const canRead = hasAnyRole([AdminRole.Superadmin, AdminRole.CatalogueRead])
	const canEdit = hasRole(AdminRole.Superadmin)
	const { configVersion, isLoading, error, refetch } = useCrawlConfig({
		enabled: canRead,
	})

	if (error || isLoading || !configVersion) {
		return (
			<div className="space-y-6 px-6 pt-6 pb-10">
				<div className="space-y-1">
					<h1 className="text-2xl font-bold tracking-tight">
						{CRAWL_SETTINGS_TITLE}
					</h1>
					<p className="text-sm text-muted-foreground">
						{CRAWL_SETTINGS_DESCRIPTION}
					</p>
				</div>
				{error ? (
					<div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4">
						<p className="text-sm text-destructive">
							The settings could not be loaded: {error.message}
						</p>
					</div>
				) : (
					<div className="grid items-start gap-6 xl:grid-cols-[minmax(0,1fr)_22rem]">
						<div className="space-y-6">
							<Skeleton className="h-64 w-full" />
							<Skeleton className="h-40 w-full" />
							<Skeleton className="h-56 w-full" />
						</div>
						<Skeleton className="h-72 w-full" />
					</div>
				)}
			</div>
		)
	}

	return (
		<CrawlConfigEditor
			active={configVersion}
			canEdit={canEdit}
			onReload={() => refetch()}
		/>
	)
}
